// The assigner's assistant beside the compact schedule, so a command and the
// grid it changes stay in view together. Every message from here names the
// tournament and the day on screen, which is what "field 5 from 10:20" means.

import ClipLoader from 'react-spinners/ClipLoader';
import { assistantChatId, ASSISTANT_NAME } from '../utils/chat';
import { useFirebase } from './FirebaseContextProvider';
import ChatThread from './ChatThread';
import './AssistantPanel.scss';

export default function AssistantPanel({
  tournamentId,
  date,
  isOpen,
  onToggle,
}) {
  const { user, chats, isChatsSynced } = useFirebase();
  const chat = chats.find((c) => c.id === assistantChatId(user?.id));
  const preview = chat?.lastMessage?.text ?? chat?.lastMessage?.title ?? '';

  return (
    <aside className={'assistant-panel' + (isOpen ? ' open' : '')}>
      <button
        className='panel-head'
        onClick={onToggle}
        aria-expanded={isOpen}
        title={isOpen ? 'Collapse' : 'Expand'}
      >
        <span className='fa-comments-o' />
        <span className='head-text'>
          <span className='name'>{ASSISTANT_NAME}</span>
          {!isOpen && preview && (
            <span className='preview font-12'>{preview}</span>
          )}
        </span>
        {!isOpen && chat?.hasUnread && <span className='unread-dot' />}
        <span className={isOpen ? 'fa-chevron-up' : 'fa-chevron-down'} />
      </button>

      {/* Mounted only while open, so a collapsed panel holds no listener
          and no microphone */}
      {isOpen && (
        <div className='panel-body'>
          {chat ? (
            <ChatThread
              key={chat.id}
              chat={chat}
              docked
              context={{ tournamentId, date }}
            />
          ) : isChatsSynced ? (
            // A conclusion from absence, so it waits for the server
            <p className='empty'>The assistant is not available yet</p>
          ) : (
            <div className='loading'>
              <ClipLoader size={24} color='#3f90dc' />
            </div>
          )}
        </div>
      )}
    </aside>
  );
}
